import React, { useState, ChangeEvent, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Alert,
  Box,
  CircularProgress,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Link,
  FormControlLabel,
  Switch
  , Dialog, DialogTitle, DialogContent, DialogActions, Snackbar
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../theme/theme';

const siteVitrineLayouts = [
  { id: 'accommodation', name: 'Accommodation' },
  { id: 'accountant', name: 'Accountant' },
  { id: 'agency', name: 'Agency' },
  { id: 'author', name: 'Author' },
  { id: 'babershop', name: 'Babershop' },
  { id: 'bakery', name: 'Bakery' },
  { id: 'banking', name: 'Banking' },
  { id: 'beauty', name: 'Beauty' },
  { id: 'bistro', name: 'Bistro' },
  { id: 'brewery', name: 'Brewery' },
  { id: 'business', name: 'Business' },
  { id: 'cafe', name: 'Cafe' },
  { id: 'charity', name: 'Charity' },
  { id: 'church', name: 'Church' },
  { id: 'cleaning', name: 'Cleaning' },
  { id: 'club', name: 'Club' },
  { id: 'consulting', name: 'Consulting' },
  { id: 'construction', name: 'Construction' },
  { id: 'copywriter', name: 'Copywriter' },
  { id: 'corporate', name: 'Corporate' },
  { id: 'creative', name: 'Creative' },
  { id: 'developer', name: 'Developer' },
  { id: 'electrical', name: 'Electrical' },
  { id: 'energy', name: 'Energy' },
  { id: 'farmers.market', name: 'Farmers Market' },
  { id: 'fitness', name: 'Fitness' },
  { id: 'florist', name: 'Florist' },
  { id: 'freelancer', name: 'Freelancer' },
  { id: 'garage', name: 'Garage' },
  { id: 'gardener', name: 'Gardener' },
  { id: 'handyman', name: 'Handyman' },
  { id: 'hosting', name: 'Hosting' },
  { id: 'insurance', name: 'Insurance' },
  { id: 'interior.design', name: 'Interior Design' },
  { id: 'it.services', name: 'IT Services' },
  { id: 'jeweler', name: 'Jeweler' },
  { id: 'lawyer', name: 'Lawyer' },
  { id: 'marketing', name: 'Marketing' },
  { id: 'medical', name: 'Medical' },
  { id: 'nutritionist', name: 'Nutritionist' },
  { id: 'photography', name: 'Photography' },
  { id: 'pizzeria', name: 'Pizzeria' },
  { id: 'portfolio', name: 'Portfolio' },
  { id: 'seo.agency', name: 'SEO Agency' },
  { id: 'sushi', name: 'Sushi' },
  { id: 'transport', name: 'Transport' },
  { id: 'travel', name: 'Travel' },
  { id: 'university', name: 'University' },
  { id: 'vetcare', name: 'Vetcare' },
  { id: 'winery', name: 'Winery' },
  { id: 'yoga', name: 'Yoga' },
  
];

const boutiqueLayouts = [
  { id: 'boutique.accommodation', name: 'Boutique Accommodation' },
  { id: 'boutique.accountant', name: 'Boutique Accountant' },
  { id: 'boutique.agency', name: 'Boutique Agency' },
  { id: 'boutique.author', name: 'Boutique Author' },
  { id: 'boutique.babershop', name: 'Boutique Babershop' },
  { id: 'boutique.bakery', name: 'Boutique Bakery' },
  { id: 'boutique.banking', name: 'Boutique Banking' },
  { id: 'boutique.beauty', name: 'Boutique Beauty' },
  { id: 'boutique.bistro', name: 'Boutique Bistro' },
  { id: 'boutique.brewery', name: 'Boutique Brewery' },
  { id: 'boutique.business', name: 'Boutique Business' },
  { id: 'boutique.cafe', name: 'Boutique Cafe' },
  { id: 'boutique.charity', name: 'Boutique Charity' },
  { id: 'boutique.church', name: 'Boutique Church' },
  { id: 'boutique.cleaning', name: 'Boutique Cleaning' },
  { id: 'boutique.club', name: 'Boutique Club' },
  { id: 'boutique.consulting', name: 'Boutique Consulting' },
  { id: 'boutique.construction', name: 'Boutique Construction' },
  { id: 'boutique.copywriter', name: 'Boutique Copywriter' },
  { id: 'boutique.corporate', name: 'Boutique Corporate' },
  { id: 'boutique.creative', name: 'Boutique Creative' },
  { id: 'boutique.developer', name: 'Boutique Developer' },
  { id: 'boutique.electrical', name: 'Boutique Electrical' },
  { id: 'boutique.energy', name: 'Boutique Energy' },
  { id: 'boutique.farmers.market', name: 'Boutique Farmers Market' },
  { id: 'boutique.fitness', name: 'Boutique Fitness' },
  { id: 'boutique.florist', name: 'Boutique Florist' },
  { id: 'boutique.freelancer', name: 'Boutique Freelancer' },
  { id: 'boutique.garage', name: 'Boutique Garage' },
  { id: 'boutique.gardener', name: 'Boutique Gardener' },
  { id: 'boutique.handyman', name: 'Boutique Handyman' },
  { id: 'boutique.hosting', name: 'Boutique Hosting' },
  { id: 'boutique.insurance', name: 'Boutique Insurance' },
  { id: 'boutique.interior_design', name: 'Boutique Interior Design' },
  { id: 'boutique.it.services', name: 'Boutique IT Services' },
  { id: 'boutique.jeweler', name: 'Boutique Jeweler' },
  { id: 'boutique.lawyer', name: 'Boutique Lawyer' },
  { id: 'boutique.marketing', name: 'Boutique Marketing' },
  { id: 'boutique.medical', name: 'Boutique Medical' },
  { id: 'boutique.nutritionist', name: 'Boutique Nutritionist' },
  { id: 'boutique.photography', name: 'Boutique Photography' },
  { id: 'boutique.pizzeria', name: 'Boutique Pizzeria' },
  { id: 'boutique.portfolio', name: 'Boutique Portfolio' },
  { id: 'boutique.seo.agency', name: 'Boutique SEO Agency' },
  { id: 'boutique.sushi', name: 'Boutique Sushi' },
  { id: 'boutique.transport', name: 'Boutique Transport' },
  { id: 'boutique.travel', name: 'Boutique Travel' },
  { id: 'boutique.university', name: 'Boutique University' },
  { id: 'boutique.vetcare', name: 'Boutique Vetcare' },
  { id: 'boutique.winery', name: 'Boutique Winery' },
  { id: 'boutique.yoga', name: 'Boutique Yoga' },
  
];

const createurLayouts = [
  { id: 'boutique.maitre', name: 'Boutique Maitre' },
  { id: 'maitre', name: 'Maitre' },
];

// No example/fictive URLs stored — only real backend data will be used

const WordPressMockupForm: React.FC = () => {
  const [localdomain, setLocaldomain] = useState('');
  const [prenom, setPrenom] = useState('');
  const [nom, setNom] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [siteTitle, setSiteTitle] = useState('');
  const [siteType, setSiteType] = useState('');
  const [selectedLayout, setSelectedLayout] = useState('');
  const [submissionStatus, setSubmissionStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState<React.ReactNode>('');
  const [logs, setLogs] = useState<Array<{
    timestamp: string;
    message: string;
    status: 'info' | 'success' | 'error';
  }>>([]);
  const [isPolling, setIsPolling] = useState(false);
  const [jobId, setJobId] = useState<string | null>(null);
  const [siteUrl, setSiteUrl] = useState<string | null>(null);
  const [siteCredentials, setSiteCredentials] = useState<string | null>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  // Détection automatique de l'environnement :
  // - En local (npm start) : REACT_APP_API_URL est vide → le proxy CRA de package.json
  //   achemine automatiquement /api/... vers http://localhost:5000 (Flask local)
  // - En production (npm run build) : REACT_APP_API_URL contient l'URL o2switch,
  //   intégrée dans le bundle au moment du build
  // apiBase — build 2026-02-24
  const apiBase = (() => {
    const fromEnv = process.env.REACT_APP_API_URL;
    if (fromEnv !== undefined && fromEnv !== '') return fromEnv;
    // Fallback : si on n'est pas sur localhost, pointer vers la prod
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return '';
    // Backend Flask monté sur demo-digiibuz.fr/Digii-Tools/DigiiMultiMaquettes (Passenger)
    return 'https://demo-digiibuz.fr/Digii-Tools/DigiiMultiMaquettes';
  })();

  const sanitizeEmail = (email: string): string => {
    return email.toLowerCase().replace(/[^a-zA-Z0-9@.-]/g, '');
  };

  const validateEmail = (email: string): boolean => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const getFriendlyMessage = (apiMessage: string): React.ReactNode => {
    if (!apiMessage) {
      return 'Erreur inconnue lors de la création de la maquette.';
    }

    if (apiMessage.includes('URL:') && apiMessage.includes('Identifiants:')) {
      const lines = apiMessage.split('\n');
      const urlLine = lines.find((line: string) => line.startsWith('URL:'));
      const credsLine = lines.find((line: string) => line.startsWith('Identifiants:'));
      const url = urlLine?.split(' ')[1];
      const credentials = credsLine?.split(' ')[1];

      return (
        <>
          Création de la maquette réussie !
          <br />
          {url && (
            <>
              URL : <Link href={url} target="_blank" rel="noopener noreferrer">{url}</Link>
              <br />
            </>
          )}
          {credentials && <>Identifiants : {credentials}</>}
        </>
      );
    }

    if (apiMessage.includes('non reconnu')) {
      return "Le layout de maquette demandé n'existe pas.";
    }
    if (apiMessage.includes('manquant(s)')) {
      return "Un ou plusieurs paramètres nécessaires n'ont pas été fournis dans la requête.";
    }
    if (apiMessage.includes("'prenom' et 'nom' sont requis")) {
      return "Les informations de l'utilisateur (prénom, nom) sont manquantes.";
    }
    if (apiMessage.includes('sous-domaine échouée')) {
      return "La création du sous-domaine a échoué. Il est possible qu'il soit déjà utilisé.";
    }
    if (apiMessage.includes('base de données échouée')) {
      return "Une erreur est survenue lors de la configuration de la base de données.";
    }
    if (apiMessage.includes('adresse IP échouée')) {
      return "Le système n'a pas pu obtenir l'adresse IP nécessaire pour la configuration.";
    }

    return apiMessage;
  };

  const extractUrlAndCredsFromText = React.useCallback((text?: string) => {
    if (!text) return { url: null, creds: null };
    const lines = text.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
    let url: string | null = null;
    let creds: string | null = null;

    for (const line of lines) {
      // look for http(s) links first — match until whitespace
      const match = line.match(/(https?:\/\/\S+)/);
      if (match) {
        url = match[1];
      }
      if (/^(URL:)\s*/i.test(line) && !url) {
        const parts = line.split(/:\s*/);
        if (parts[1]) url = parts.slice(1).join(':').trim();
      }
      if (/identifiants|credentials/i.test(line)) {
        const parts = line.split(/:\s*/);
        creds = parts.slice(1).join(':').trim();
      }
    }

    // No example URLs to filter here — keep whatever the backend returns

    return { url, creds };
  }, []);

  // Simple confetti launcher: creates temporary DOM nodes and animates them then removes
  const launchConfetti = React.useCallback(() => {
    const colors = ['#ffcc00', '#ff5c5c', '#5cdbff', '#9bff9b', '#c58cff'];
    const count = 30;
    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.pointerEvents = 'none';
    container.style.top = '0';
    container.style.left = '0';
    container.style.width = '100%';
    container.style.height = '0';
    container.style.overflow = 'visible';
    container.style.zIndex = '9999';
    document.body.appendChild(container);

    for (let i = 0; i < count; i++) {
      const el = document.createElement('div');
      const size = Math.floor(Math.random() * 10) + 6;
      el.style.position = 'absolute';
      el.style.width = `${size}px`;
      el.style.height = `${size * 0.6}px`;
      el.style.background = colors[Math.floor(Math.random() * colors.length)];
      el.style.left = `${Math.random() * 100}%`;
      el.style.top = `-10px`;
      el.style.opacity = '0.95';
      el.style.transform = `rotate(${Math.random() * 360}deg)`;
      el.style.borderRadius = '2px';
      el.style.willChange = 'transform, top, opacity';
      container.appendChild(el);

      const duration = 2000 + Math.random() * 2000;
      // animate with requestAnimationFrame fallback
      const start = performance.now();
      const startLeft = parseFloat(el.style.left);
      const drift = (Math.random() - 0.5) * 30;
      const frame = (now: number) => {
        const t = Math.min(1, (now - start) / duration);
        el.style.top = `${t * (window.innerHeight + 100)}px`;
        el.style.left = `${startLeft + drift * t}%`;
        el.style.opacity = `${1 - t}`;
        el.style.transform = `rotate(${t * 720 + Math.random() * 60}deg)`;
        if (t < 1) requestAnimationFrame(frame);
        else el.remove();
      };
      requestAnimationFrame(frame);
    }

    // remove container after animations
    setTimeout(() => { container.remove(); }, 4500);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmissionStatus('submitting');
    setMessage('');
    setLogs([]);
    setIsPolling(false);

    // Frontend Validation
    if (!localdomain.trim() || !prenom.trim() || !nom.trim() || !email.trim() || !siteTitle.trim() || !selectedLayout.trim() || !firstName.trim() || !lastName.trim()) {
      setMessage('Tous les champs sont requis.');
      setSubmissionStatus('error');
      return;
    }
    if (!validateEmail(email)) {
      setMessage('Une adresse email valide est requise.');
      setSubmissionStatus('error');
      return;
    }

    setIsPolling(true);

    try {
    const apiUrl = `${apiBase}/api/creer/${selectedLayout}`;

      const body = {
        prenom: firstName.trim(),
        nom: lastName.trim(),
        localdomain: localdomain.trim(),
        email: email.trim(),
        site_title: siteTitle.trim(),
        name: `${nom.trim()}-${prenom.trim()}`
      };

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });

      let data;
      const textResponse = await response.text();
      
      try {
        data = JSON.parse(textResponse);

        if (response.ok) {
          setSubmissionStatus('success');
          setMessage('');
          // Stocker le job_id pour le polling des logs
          if (data.job_id) setJobId(data.job_id);
          // try to extract url/credentials from the response message or from known fields
          const raw = data.message || data.msg || data.output || '';
          const { url, creds } = extractUrlAndCredsFromText(typeof raw === 'string' ? raw : JSON.stringify(raw));
          // If backend did not provide a URL, construct one from the submitted localdomain
          const constructed = localdomain ? `https://${localdomain}.demo-digiibuz.fr` : null;
          const finalUrl = url || constructed;
          if (finalUrl) setSiteUrl(finalUrl);
          if (creds) setSiteCredentials(creds);
          setShowPopup(true);
        } else {
          setSubmissionStatus('error');
          setMessage(getFriendlyMessage(data.error || data.message));
          setIsPolling(false); // Arrêter le polling en cas d'erreur finale
        }
      } catch (parseError) {
        console.error('Failed to parse response:', textResponse, parseError);
        setSubmissionStatus('error');
        // Afficher la réponse texte brute si le JSON est invalide, car elle peut contenir un message d'erreur utile
        setMessage(`Erreur de format de réponse du serveur : ${textResponse}`);
        setIsPolling(false);
      }
    } catch (error: any) {
      console.error('Request error:', error);
      setSubmissionStatus('error');
      setMessage(`Erreur de connexion : ${error.message}`);
      setIsPolling(false);
    }
  };

  const fetchLogs = React.useCallback(async () => {
    try {
      // Utiliser job_id si disponible pour obtenir les logs du job en cours
      const url = jobId
        ? `${apiBase}/api/logs?job_id=${jobId}&limit=200`
        : `${apiBase}/api/logs`;
      const response = await fetch(url);
      if (!response.ok) return [];
      const data = await response.json();
      if (Array.isArray(data)) {
        return data;
      }
      // Si la réponse est un objet (ex: {"status":"ok"}) → ignorer silencieusement
      return [];
    } catch (error) {
      console.error('Error fetching logs:', error);
      return [];
    }
  }, [apiBase, jobId]);

  useEffect(() => {
    let pollInterval: NodeJS.Timeout | null = null;  // Changement du type ici

    const updateLogs = async () => {
      if (isPolling) {
        const newLogs = await fetchLogs();
        setLogs(newLogs);
        // If we don't already have a siteUrl, try to find one in the logs
        if (!siteUrl && Array.isArray(newLogs)) {
          for (const log of newLogs) {
            const { url, creds } = extractUrlAndCredsFromText(log.message);
            if (url) {
              setSiteUrl(url);
            }
            if (creds) {
              setSiteCredentials(creds);
            }
            if (url && creds) break;
          }
        }
      }
  };

    if (isPolling) {
      updateLogs();
      pollInterval = setInterval(updateLogs, 2000);
    }

    return () => {
      if (pollInterval) {
        clearInterval(pollInterval);
      }
    };
  }, [isPolling, siteUrl, extractUrlAndCredsFromText, fetchLogs]);

  // Launch confetti when the popup opens
  useEffect(() => {
    if (showPopup) {
      launchConfetti();
    }
  }, [showPopup, launchConfetti]);

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center" 
            sx={{ mb: 4, color: 'white', borderBottom: '1px solid rgba(255,255,255,0.1)', pb: 2 }}>
            Générateur de Maquette WordPress
          </Typography>

          {message && (
            <Alert severity={submissionStatus === 'success' ? 'success' : 'error'} 
              sx={{ mb: 3 }}>
              {message}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              <TextField
                label="Sous-domaine local"
                value={localdomain}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setLocaldomain(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
                required
              />

              <TextField
                label="Prénom (minuscule sans accent)"
                value={prenom}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setPrenom(e.target.value.toLowerCase())}
                required
              />

              <TextField
                label="Nom (minuscule sans accent)"
                value={nom}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setNom(e.target.value.toLowerCase())}
                required
              />

              <TextField
                label="Prénom profil éditeur"
                value={firstName}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                required
              />

              <TextField
                label="Nom profil éditeur"
                value={lastName}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                required
              />

              <TextField
                label="Email"
                type="email"
                value={email}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(sanitizeEmail(e.target.value))}
                required
              />

              <TextField
                label="Titre du site"
                value={siteTitle}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setSiteTitle(e.target.value)}
                required
              />

              <FormControl fullWidth>
                <InputLabel>Type de site</InputLabel>
                <Select
                  value={siteType}
                  label="Type de site"
                  onChange={(e: SelectChangeEvent<string>) => {
                    setSiteType(e.target.value);
                    setSelectedLayout('');
                  }}
                  required
                >
                  <MenuItem value="">Sélectionner un type</MenuItem>
                  <MenuItem value="vitrine">Site vitrine</MenuItem>
                  <MenuItem value="boutique">Boutique</MenuItem>
                  <MenuItem value="createur">Créateur de maquette</MenuItem>
                </Select>
              </FormControl>

              {siteType && (
                <FormControl fullWidth>
                  <InputLabel>Layout</InputLabel>
                  <Select
                    value={selectedLayout}
                    label="Layout"
                    onChange={(e: SelectChangeEvent<string>) => setSelectedLayout(e.target.value)}
                    required
                  >
                    <MenuItem value="">Sélectionner un layout</MenuItem>
                    {(siteType === 'vitrine'
                      ? siteVitrineLayouts
                      : siteType === 'boutique'
                      ? boutiqueLayouts
                      : createurLayouts
                    ).map((layout) => (
                      <MenuItem key={layout.id} value={layout.id}>
                        {layout.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              <Button
                type="submit"
                variant="contained"
                size="large"
                disabled={submissionStatus === 'submitting'}
                sx={{ mt: 2 }}
              >
                {submissionStatus === 'submitting' ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={20} color="inherit" />
                    Création en cours...
                  </Box>
                ) : (
                  'Créer maquette'
                )}
              </Button>
            </Box>
          </form>
        </Paper>

        <Paper elevation={3} sx={{ mt: 4, p: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h6" component="h2">
              Logs de création
              {isPolling && (
                <CircularProgress size={20} sx={{ ml: 2 }} />
              )}
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={isPolling}
                  onChange={(e) => setIsPolling(e.target.checked)}
                  color="primary"
                />
              }
              label="Actualisation automatique"
            />
          </Box>

          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>Horodatage</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Message</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Statut</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      {submissionStatus === 'idle'
                        ? 'En attente de génération...'
                        : isPolling
                        ? 'En attente des logs...'
                        : 'Activez l\'actualisation pour voir les logs'}
                    </TableCell>
                  </TableRow>
                ) : (
                  logs.map((log, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {new Date(log.timestamp).toLocaleString()}
                      </TableCell>
                      <TableCell>
                        {/* Replace any displayed example URLs with the actual subdomain from the form if available */}
                        {log.message.includes('http') ? (
                          <Box>
                            {log.message.split('\n').map((line, i) => {
                              const hasHttp = line.includes('http');
                              let display = line;
                              if (localdomain && hasHttp) {
                                display = `${localdomain}.demo-digiibuz.fr`;
                              }
                              return (
                                <Typography key={i} variant="body2">
                                  {hasHttp ? (
                                    <Link href={`https://${display}`} target="_blank" rel="noopener noreferrer">
                                      {display}
                                    </Link>
                                  ) : (
                                    display
                                  )}
                                </Typography>
                              );
                            })}
                          </Box>
                        ) : (
                          log.message
                        )}
                      </TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          label={log.status}
                          color={
                            log.status === 'success'
                              ? 'success'
                              : log.status === 'error'
                              ? 'error'
                              : 'info'
                          }
                          sx={{ 
                            minWidth: 80,
                            backgroundColor: log.status === 'success' 
                              ? 'rgba(46, 125, 50, 0.2)'
                              : log.status === 'error'
                              ? 'rgba(211, 47, 47, 0.2)'
                              : 'rgba(2, 136, 209, 0.2)'
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* site URL paper removed — popup will show generated link on success */}
        
        <Dialog
          open={showPopup}
          onClose={() => setShowPopup(false)}
          aria-labelledby="generated-site-dialog"
        >
          <DialogTitle id="generated-site-dialog">Maquette créée 🎉</DialogTitle>
          <DialogContent>
            <Typography variant="h6">Félicitations ! Ta maquette est prête.</Typography>
            {siteUrl ? (
              <Box sx={{ mt: 2 }}>
                <Link href={siteUrl} target="_blank" rel="noopener noreferrer">{siteUrl}</Link>
                {siteCredentials && (
                  <Typography variant="body2" sx={{ mt: 1 }}>Identifiants: {siteCredentials}</Typography>
                )}
              </Box>
            ) : (
              <Typography variant="body2" sx={{ mt: 2 }}>Aucun lien détecté automatiquement.</Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              if (siteUrl) {
                try { window.open(siteUrl, '_blank'); } catch(e) { console.error(e); }
              }
            }}>Ouvrir</Button>
            <Button onClick={async () => {
              if (siteUrl) {
                try { await navigator.clipboard.writeText(siteUrl); setSnackbarMessage('Lien copié dans le presse-papiers'); setSnackbarOpen(true); } catch(e) { console.error(e); }
              }
            }}>Copier</Button>
            <Button onClick={() => setShowPopup(false)}>Fermer</Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={() => setSnackbarOpen(false)}
          message={snackbarMessage}
        />
      </Container>
    </ThemeProvider>
  );
};

export default WordPressMockupForm;